function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M57,3v54H3V3H57 M60,0H0v60h60V0L60,0z"
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M27,33v24H3V33H27 M30,30H0v30h30V30L30,30z"
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("polygon", {
  points: "46.5,30 43.5,30 43.5,16.5 30,16.5 30,13.5 46.5,13.5  "
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 28.5,
  y: 8.8,
  transform: "matrix(0.7071 0.7071 -0.7071 0.7071 30 -12.4264)",
  width: 3,
  height: 42.4
})))));

var SvgPositioning = function SvgPositioning(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/positioning.b55cb4b6.svg";
export { SvgPositioning as ReactComponent };